import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "mb-3" }, "Add New Member", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-success mb-3"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "Name" }, [
  /*#__PURE__*/_createTextVNode("First Name "),
  /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*")
], -1)
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "Name" }, [
  /*#__PURE__*/_createTextVNode("Last Name "),
  /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "Email" }, [
  /*#__PURE__*/_createTextVNode("Enter Email Address "),
  /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "Name" }, [
  /*#__PURE__*/_createTextVNode("Select Role "),
  /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*")
], -1)
const _hoisted_16 = { class: "dropdown-wrap unit-dropdown position-relative bg-white" }
const _hoisted_17 = { class: "mr-3" }
const _hoisted_18 = { class: "dropdown-actions" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_26 = {
  key: 0,
  class: "form-check-label ml-3"
}
const _hoisted_27 = { class: "align-text-top" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_30 = {
  key: 0,
  class: "form-check-label ml-3"
}
const _hoisted_31 = { class: "align-text-top" }
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "Name" }, [
  /*#__PURE__*/_createTextVNode("Amount Type "),
  /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*")
], -1)
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-sm-8" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "dropdown-wrap unit-dropdown position-relative bg-white" }
const _hoisted_39 = { class: "mr-3" }
const _hoisted_40 = { class: "dropdown-actions" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_45 = { class: "col-sm-4" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Approval required ")
const _hoisted_51 = {
  key: 1,
  class: "row"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_53 = { class: "time-slot-block mb-2" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "row mt-2" }
const _hoisted_56 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "Start Date/Time:")
  ])
], -1)
const _hoisted_58 = { class: "text-success" }
const _hoisted_59 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "End Date/Time:")
  ])
], -1)
const _hoisted_61 = { class: "text-danger" }
const _hoisted_62 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-success" }, [
    /*#__PURE__*/_createVNode("small", null, [
      /*#__PURE__*/_createVNode("strong", null, "All Day")
    ])
  ])
], -1)
const _hoisted_64 = {
  key: 2,
  class: "remove-btn text-end"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_67 = { class: "modal-wrap default-modal" }
const _hoisted_68 = {
  class: "modal fade",
  id: "addNewmemberRole",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_69 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_70 = { class: "modal-content" }
const _hoisted_71 = { class: "modal-header" }
const _hoisted_72 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_73 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_75 = { class: "modal-body" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/_createVNode("label", { for: "" }, "Name", -1)
const _hoisted_78 = {
  key: 0,
  class: "form-group"
}
const _hoisted_79 = /*#__PURE__*/_createVNode("label", { for: "" }, "Phase Permissions ", -1)
const _hoisted_80 = { class: "inline-items" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "align-text-top" }
const _hoisted_83 = {
  key: 1,
  class: "form-group"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { for: "" }, "Task Permissions ", -1)
const _hoisted_85 = { class: "inline-items" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "align-text-top" }
const _hoisted_88 = { class: "modal-footer" }
const _hoisted_89 = { class: "modal-wrap default-modal" }
const _hoisted_90 = {
  class: "modal fade",
  id: "addNewAmountType",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_91 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_92 = { class: "modal-content" }
const _hoisted_93 = { class: "modal-header" }
const _hoisted_94 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_95 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_97 = { class: "modal-body" }
const _hoisted_98 = { class: "form-group" }
const _hoisted_99 = /*#__PURE__*/_createVNode("label", { for: "" }, "Name", -1)
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = /*#__PURE__*/_createVNode("label", { for: "" }, "Type ", -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("option", {
  value: "selected",
  disabled: true,
  selected: true
}, " Click To Select Type ", -1)
const _hoisted_103 = { class: "modal-footer" }
const _hoisted_104 = { class: "modal-wrap default-modal" }
const _hoisted_105 = {
  class: "modal fade",
  id: "deleteRoleModel",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "addFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header" }
const _hoisted_109 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "addFavPojectLabel"
}, " Delete ", -1)
const _hoisted_110 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-danger mb-0",
    role: "alert"
  }, " Are you sure you want to delete? ")
], -1)
const _hoisted_112 = { class: "modal-footer" }
const _hoisted_113 = { class: "modal-wrap default-modal" }
const _hoisted_114 = {
  class: "modal fade",
  id: "deleteAmountTypeModel",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "addFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_115 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_116 = { class: "modal-content" }
const _hoisted_117 = { class: "modal-header" }
const _hoisted_118 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "addFavPojectLabel"
}, " Delete ", -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_120 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-danger mb-0",
    role: "alert"
  }, " Are you sure you want to delete? ")
], -1)
const _hoisted_121 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _hoisted_1,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.members, (member, memberIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: "border p-3 rounded mb-3 bg-light",
          key: `existing${memberIndex}`
        }, [
          (member.isExist)
            ? (_openBlock(), _createBlock("p", _hoisted_2, "Already Existed member with invitation accepted !!!"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => (member.first_name = $event)
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, member.first_name]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => (member.last_name = $event)
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, member.last_name]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => (member.email = $event)
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, member.email]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, [
                  _createVNode("a", {
                    class: "dropdown-toggle d-block border rounded py-2 px-3",
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-expanded": "false",
                    disabled: _ctx.state.ui.isLoading.isShow
                  }, [
                    _createVNode("span", _hoisted_17, _toDisplayString(member.role.id
                    ? member.role.name
                    : "Choose Role"), 1)
                  ], 8, ["disabled"]),
                  _createVNode("div", {
                    class: "dropdown-menu custom-scroll table-dropdown",
                    disabled: _ctx.state.ui.isLoading.isShow
                  }, [
                    (_ctx.userRole === 1)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "dropdown-item border-bottom text-success",
                          href: "javascript:void(0)",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewUnit(null)))
                        }, "+ Add New Role"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roles, (role, roleIndex) => {
                      return (_openBlock(), _createBlock("a", {
                        class: "dropdown-item with-actions",
                        href: "javascript:void(0)",
                        key: roleIndex
                      }, [
                        _createVNode("span", {
                          class: "unit-title d-block",
                          onClick: ($event: any) => (_ctx.selectUnit(member, memberIndex, role))
                        }, _toDisplayString(role.name), 9, ["onClick"]),
                        _createVNode("span", _hoisted_18, [
                          (_ctx.userRole === 1)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: "actions-text",
                                onClick: ($event: any) => (_ctx.editRole(role))
                              }, [
                                _hoisted_19,
                                _hoisted_20
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.userRole === 1)
                            ? (_openBlock(), _createBlock("span", {
                                key: 1,
                                class: "actions-text ml-2",
                                onClick: ($event: any) => (_ctx.showDeleteRole(role))
                              }, [
                                _hoisted_21,
                                _hoisted_22
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ], 8, ["disabled"])
                ])
              ]),
              (member.role && member.role.permissions && member.role.permissions.length)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(member.role.permissions, (permission, permissionIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: `permi${permissionIndex}`
                      }, [
                        (_ctx.activeTab === 'phase')
                          ? (_openBlock(), _createBlock("div", _hoisted_24, [
                              (permission.id === 8 || permission.id === 6 || permission.id === 3 || permission.id === 2 || permission.id === 1 || permission.id === 7)
                                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                    _createVNode("input", {
                                      type: "checkbox",
                                      checked: permission.isChecked,
                                      onChange: ($event: any) => (_ctx.permissionByUser(memberIndex, permissionIndex, $event))
                                    }, null, 40, ["checked", "onChange"]),
                                    (permission && permission.name)
                                      ? (_openBlock(), _createBlock("label", _hoisted_26, [
                                          _createVNode("small", _hoisted_27, _toDisplayString(permission.name), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_28, [
                              (permission.id === 4 || permission.id === 5)
                                ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                    _createVNode("input", {
                                      type: "checkbox",
                                      checked: permission.isChecked,
                                      onChange: ($event: any) => (_ctx.permissionByUser(memberIndex, permissionIndex, $event))
                                    }, null, 40, ["checked", "onChange"]),
                                    (permission && permission.name)
                                      ? (_openBlock(), _createBlock("label", _hoisted_30, [
                                          _createVNode("small", _hoisted_31, _toDisplayString(permission.name), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_32
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("a", {
                        class: "dropdown-toggle d-block border rounded py-2 px-3",
                        type: "button",
                        "data-toggle": "dropdown",
                        "aria-expanded": "false",
                        disabled: _ctx.state.ui.isLoading.isShow
                      }, [
                        _createVNode("span", _hoisted_39, _toDisplayString(member.amountType.id
                        ? member.amountType.name
                        : "Choose Amount Type"), 1)
                      ], 8, ["disabled"]),
                      _createVNode("div", {
                        class: "dropdown-menu custom-scroll table-dropdown",
                        disabled: _ctx.state.ui.isLoading.isShow
                      }, [
                        (_ctx.userRole === 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              class: "dropdown-item border-bottom text-success",
                              href: "javascript:void(0)",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addAmountType(null)))
                            }, "+ Add New Amount Type"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.amountTypes, (amount, amountIndex) => {
                          return (_openBlock(), _createBlock("a", {
                            class: "dropdown-item with-actions",
                            href: "javascript:void(0)",
                            key: amountIndex
                          }, [
                            _createVNode("span", {
                              class: "unit-title d-block",
                              onClick: ($event: any) => (_ctx.selectAmountType(member, amount))
                            }, _toDisplayString(amount.name), 9, ["onClick"]),
                            _createVNode("span", _hoisted_40, [
                              (_ctx.userRole === 1)
                                ? (_openBlock(), _createBlock("span", {
                                    key: 0,
                                    class: "actions-text",
                                    onClick: ($event: any) => (_ctx.editAmountType(amount))
                                  }, [
                                    _hoisted_41,
                                    _hoisted_42
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.userRole === 1)
                                ? (_openBlock(), _createBlock("span", {
                                    key: 1,
                                    class: "actions-text ml-2",
                                    onClick: ($event: any) => (_ctx.showDeleteAmountType(amount))
                                  }, [
                                    _hoisted_43,
                                    _hoisted_44
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ], 8, ["disabled"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "$0.00",
                      "onUpdate:modelValue": ($event: any) => (member.amountTypeNumber = $event)
                    }, null, 8, ["onUpdate:modelValue"]), [
                      [_vModelText, member.amountTypeNumber]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("button", {
                class: "btn default-btn btn-sm",
                disabled: _ctx.isNotEmail(member.email)|| !member.first_name || !member.last_name,
                onClick: ($event: any) => (_ctx.showAvaibilityModalByUser(member, memberIndex))
              }, " Check Member's Availability ", 8, ["disabled", "onClick"])
            ]),
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _createVNode("label", null, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    name: "agree",
                    id: "agree-checkbox",
                    "onUpdate:modelValue": ($event: any) => (member.approval_required = $event)
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelCheckbox, member.approval_required]
                  ]),
                  _hoisted_50
                ])
              ])
            ])
          ]),
          (member.filteredSlots && member.filteredSlots.length)
            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(member.filteredSlots, (time, timeIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-md-4",
                    key: timeIndex
                  }, [
                    _createVNode("div", {
                      class: "shadowed-card bg-white mt-1 left-colored-border",
                      style: `border-left-color: ${time.bgColor};`
                    }, [
                      (_ctx.isShowDeleteSlot)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "remove-btnn",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.deleteSelectedTimeSlot(memberIndex, time))
                          }, [
                            _hoisted_52
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_53, [
                        (time.title)
                          ? (_openBlock(), _createBlock("p", _hoisted_54, [
                              _createVNode("strong", null, _toDisplayString(time.title) + ":", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_55, [
                          (time.formatedStart)
                            ? (_openBlock(), _createBlock("div", _hoisted_56, [
                                _hoisted_57,
                                _createVNode("p", _hoisted_58, [
                                  _createVNode("small", null, _toDisplayString(time.formatedStart), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (time.formatedEnd)
                            ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                _hoisted_60,
                                _createVNode("p", _hoisted_61, [
                                  _createVNode("small", null, _toDisplayString(time.formatedEnd), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (time.isAllday)
                          ? (_openBlock(), _createBlock("div", _hoisted_62, [
                              _hoisted_63
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 4)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowDeleteMember)
            ? (_openBlock(), _createBlock("div", _hoisted_64, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn btn-sm red-btn",
                  onClick: ($event: any) => (_ctx.selectedMember(member))
                }, [
                  _hoisted_65,
                  _hoisted_66
                ], 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_67, [
      _createVNode("div", _hoisted_68, [
        _createVNode("div", _hoisted_69, [
          _createVNode("div", _hoisted_70, [
            _createVNode("div", _hoisted_71, [
              (_ctx.state.ui.isLoading.isRoleEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_72, " Update Role "))
                : (_openBlock(), _createBlock("h5", _hoisted_73, "Add Role")),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_74
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createRole,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_76, [
                _hoisted_77,
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.name]
                ])
              ]),
              (_ctx.state.data.unit.permissionList && _ctx.state.data.unit.permissionList.length)
                ? (_openBlock(), _createBlock("div", _hoisted_78, [
                    _hoisted_79,
                    _createVNode("div", _hoisted_80, [
                      _createVNode("ul", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unit.permissionList, (permission, permissionIndex) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "mr-2",
                            key: `perm${permissionIndex}`
                          }, [
                            (permission.id === 8 || permission.id === 6 || permission.id === 3 || permission.id === 2 || permission.id === 1 || permission.id === 7)
                              ? (_openBlock(), _createBlock("div", _hoisted_81, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input ml-0",
                                    type: "checkbox",
                                    id: `permission${permissionIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (permission.isChecked = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, permission.isChecked]
                                  ]),
                                  (permission && permission.name)
                                    ? (_openBlock(), _createBlock("label", {
                                        key: 0,
                                        class: "form-check-label ml-3",
                                        for: `permission${permissionIndex}`
                                      }, [
                                        _createVNode("small", _hoisted_82, _toDisplayString(permission.name), 1)
                                      ], 8, ["for"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.unit.permissionList && _ctx.state.data.unit.permissionList.length)
                ? (_openBlock(), _createBlock("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode("div", _hoisted_85, [
                      _createVNode("ul", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unit.permissionList, (permission, permissionIndex) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "mr-2",
                            key: `perm${permissionIndex}`
                          }, [
                            (permission.id === 4 || permission.id === 5)
                              ? (_openBlock(), _createBlock("div", _hoisted_86, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input ml-0",
                                    type: "checkbox",
                                    id: `permission${permissionIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (permission.isChecked = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, permission.isChecked]
                                  ]),
                                  (permission && permission.name)
                                    ? (_openBlock(), _createBlock("label", {
                                        key: 0,
                                        class: "form-check-label ml-3",
                                        for: `permission${permissionIndex}`
                                      }, [
                                        _createVNode("small", _hoisted_87, _toDisplayString(permission.name), 1)
                                      ], 8, ["for"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_88, [
              (_ctx.state.ui.isLoading.isRoleEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateRole && _ctx.updateRole(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createRole ? "loading..." : "Update"), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createRole && _ctx.createRole(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createRole ? "loading..." : "Save"), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, " Cancel ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_89, [
      _createVNode("div", _hoisted_90, [
        _createVNode("div", _hoisted_91, [
          _createVNode("div", _hoisted_92, [
            _createVNode("div", _hoisted_93, [
              (_ctx.state.ui.isLoading.isAmountTypeEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_94, " Update Amount Type "))
                : (_openBlock(), _createBlock("h5", _hoisted_95, "Add Amount Type")),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideAmountTypeModal && _ctx.hideAmountTypeModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_96
              ])
            ]),
            _createVNode("div", _hoisted_97, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createAmountType,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_98, [
                _hoisted_99,
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.name]
                ])
              ]),
              _createVNode("div", _hoisted_100, [
                _hoisted_101,
                _withDirectives(_createVNode("select", {
                  class: "form-control w-100",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.unit.selectedAmountType = $event))
                }, [
                  _hoisted_102,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unit.amount_depends, (amount, amountIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: amount.id,
                      key: amountIndex
                    }, _toDisplayString(_ctx.state.ui.isLoading.isAmountTypeEdit && amount.ischecked ? amount.name : amount.name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.data.unit.selectedAmountType]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_103, [
              (_ctx.state.ui.isLoading.isAmountTypeEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateAmountType && _ctx.updateAmountType(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createAmountType ? "loading..." : "Update"), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.createAmountType && _ctx.createAmountType(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createAmountType ? "loading..." : "Save"), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideAmountTypeModal && _ctx.hideAmountTypeModal(...args)))
              }, " Cancel ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_104, [
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _createVNode("div", _hoisted_107, [
            _createVNode("div", _hoisted_108, [
              _hoisted_109,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteRole && _ctx.hideDeleteRole(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_110
              ])
            ]),
            _hoisted_111,
            _createVNode("div", _hoisted_112, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.deletePhaseRole && _ctx.deletePhaseRole(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.phaseRoleDelete ? "loading..." : "Yes"), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteRole && _ctx.hideDeleteRole(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_113, [
      _createVNode("div", _hoisted_114, [
        _createVNode("div", _hoisted_115, [
          _createVNode("div", _hoisted_116, [
            _createVNode("div", _hoisted_117, [
              _hoisted_118,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteAmountType && _ctx.hideDeleteAmountType(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_119
              ])
            ]),
            _hoisted_120,
            _createVNode("div", _hoisted_121, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.deletePhaseAmountType && _ctx.deletePhaseAmountType(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.amountTypeDelete ? "loading..." : "Yes"), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteAmountType && _ctx.hideDeleteAmountType(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}